import { useState, useCallback, useMemo } from "react";
import { translations, type Lang } from "@/i18n/translations";

const detectLang = (): Lang => {
  const nav = navigator.language || "en";
  return nav.startsWith("es") ? "es" : "en";
};

export const useLanguage = () => {
  const [lang, setLang] = useState<Lang>(detectLang);

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "es" ? "en" : "es"));
  }, []);

  const t = useMemo(() => translations[lang], [lang]);

  return { lang, toggleLang, t };
};
